import PropTypes from "prop-types";

const AcmgAnnotationPropTypes = {
  acmgRules: PropTypes.arrayOf(
    PropTypes.shape({
      evidence: PropTypes.string,
      met_criteria: PropTypes.bool,
      user_explain_failed: PropTypes.arrayOf(PropTypes.string),
      acmg_triggered_strength: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  classifications: PropTypes.arrayOf(PropTypes.shape({})),
  rulesThatMetCriteria: PropTypes.PropTypes.arrayOf(PropTypes.shape({})),
  activeRulesList: PropTypes.PropTypes.arrayOf(PropTypes.shape({})),
  varsomeHost: PropTypes.string,
  query: PropTypes.string.isRequired,
  queryType: PropTypes.string.isRequired,
  schema: PropTypes.shape({}),
  variantResult: PropTypes.shape({
    not_subscribed_sources: PropTypes.shape({}),
    acmg_annotation: PropTypes.shape({
      verdict: PropTypes.shape({
        ACMG_rules: PropTypes.shape({
          benign_score: PropTypes.number,
          benign_subscore: PropTypes.string,
          clinical_score: PropTypes.number,
          pathogenic_score: PropTypes.number,
          pathogenic_subscore: PropTypes.string,
          total_score: PropTypes.number,
          verdict: PropTypes.string,
        }),
      }),
      transcript_candidates: PropTypes.arrayOf(PropTypes.shape({})),
      transcript: PropTypes.string,
      transcript_reason: PropTypes.string,
      errors: PropTypes.arrayOf(
        PropTypes.shape({
          exception: PropTypes.string,
        })
      ),
      user_explain_failed: PropTypes.string,
      version_name: PropTypes.string,
      classifications: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          evidence: PropTypes.string,
          met_criteria: PropTypes.bool,
          user_explain_failed: PropTypes.arrayOf(PropTypes.string),
          strength: PropTypes.string,
        })
      ),
      throttling_info: PropTypes.shape({
        throttling_msg: PropTypes.string,
      }),
    }),
    ensembl_transcripts: PropTypes.arrayOf(
      PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape({})),
      })
    ),
    variant_id: PropTypes.string,
  }),
  allRulesToggleState: PropTypes.shape({}).isRequired,
  pillsToggleState: PropTypes.shape({}).isRequired,
  activeOverrideStrengths: PropTypes.shape({}).isRequired,
  setAcmgToggleToDefault: PropTypes.func,
  setAcmgActiveOverridesToDefault: PropTypes.func,
  setAcmgToggleState: PropTypes.func,
  setAcmgActiveOverridesStrength: PropTypes.func,
  isSomatic: PropTypes.bool.isRequired,
  acmgGene: PropTypes.string,
  cancerExplain: PropTypes.string,
  verdict: PropTypes.string,
  variantClassesList: PropTypes.arrayOf(PropTypes.shape({})),
  acmgSampleFindings: PropTypes.shape({}),
  variantQueryMode: PropTypes.shape({
    annotation_mode: PropTypes.oneOf(["", "germline", "somatic", ""]),
    phenotypes: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
      ),
      PropTypes.string,
    ]),
    diseases: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
      ),
      PropTypes.string,
    ]),
    zygosity: PropTypes.string,
    inheritance: PropTypes.string,
    age: PropTypes.string,
    ethnicity: PropTypes.string,
    sex: PropTypes.string,
    familyMembersAffected: PropTypes.string,
    familySegregation: PropTypes.string,
  }),
  componentTitle: PropTypes.string.isRequired,
  defaultVerdictRules: PropTypes.shape({
    verdict: PropTypes.string,
    pathogenic_subscore: PropTypes.string,
    approx_score: PropTypes.number,
    clinical_score: PropTypes.number,
  }),
  ensemblTranscriptsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          strand: PropTypes.string,
          coding_impact: PropTypes.string,
          function: PropTypes.arrayOf(PropTypes.string),
          hgvs: PropTypes.string,
          hgvs_p1: PropTypes.string,
          hgvs_p3: PropTypes.string,
          location: PropTypes.string,
          coding_location: PropTypes.string,
          canonical: PropTypes.bool,
          gene_symbol: PropTypes.string,
          splice_distance: PropTypes.string,
          ensembl_support_level: PropTypes.string,
        })
      ),
      version: PropTypes.string,
    })
  ),
  refseqTranscriptsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          strand: PropTypes.string,
          coding_impact: PropTypes.string,
          function: PropTypes.arrayOf(PropTypes.string),
          hgvs: PropTypes.string,
          hgvs_p1: PropTypes.string,
          hgvs_p3: PropTypes.string,
          location: PropTypes.string,
          coding_location: PropTypes.string,
          canonical: PropTypes.bool,
          gene_symbol: PropTypes.string,
          splice_distance: PropTypes.string,
          ensembl_support_level: PropTypes.string,
        })
      ),
      version: PropTypes.string,
    })
  ),
  variantId: PropTypes.string,
  shouldShowACMGPoints: PropTypes.bool,
  acmgVersionName: PropTypes.string,
  apiUrl: PropTypes.string.isRequired,
  transcriptName: PropTypes.string,
  isACMGThrottled: PropTypes.bool,
  transcriptReason: PropTypes.string,
};

const AcmgAnnotationDefaultProps = {
  schema: undefined,
  variantResult: undefined,
  acmgRules: undefined,
  classifications: undefined,
  rulesThatMetCriteria: [],
  activeRulesList: [],
  varsomeHost: "",
  acmgGene: "",
  cancerExplain: undefined,
  verdict: undefined,
  variantClassesList: null,
  setAcmgToggleToDefault: () => {},
  setAcmgActiveOverridesToDefault: () => {},
  setAcmgToggleState: () => {},
  setAcmgActiveOverridesStrength: () => {},
  acmgSampleFindings: {},
  variantQueryMode: {},
  defaultVerdictRules: null,
  ensemblTranscriptsOptions: [],
  refseqTranscriptsOptions: [],
  variantId: null,
  acmgVersionName: "",
  transcriptName: "",
  shouldShowACMGPoints: false,
  transcriptReason: null,
  isACMGThrottled: false,
};

export { AcmgAnnotationPropTypes, AcmgAnnotationDefaultProps };
